export * from './api'
import { GLOBAL_URL } from './api'

/*播放状态*/
export const SlideItemPlayStatus = {
    Play: 'Play',
    Stop: 'Stop',
    Pause: 'Pause',
}

// 不需要动画的页面
//底部tab的按钮，跳转是不需要用动画的
export const NO_ANIMATION = ['/', '/video', '/earnCash', '/wallets', '/message', '/cashout', '/events']

// 不需要登录的页面
export const NOT_LOGIN = ['/', '/login', '/iosInstruction', '/video', '/earnCash', '/earn-rule', '/events']

//手机号区号国家
export const COUNTRY_PHONE_CONFIG = [{ code: '63', value: 'PH' }]

// 充值金额
export const PAY_COUNT = [150, 200, 300, 500, 800, 1000, 1500, 2000, 4000, 7000, 10000, 20000]
// 美金提现金额
export const USD_PAY_COUNT = [10, 20, 50, 100, 500, 1000]
// 提现状态
export const GCASH_PAYStATE = {
    0: 'Unreviewed',
    1: 'Reviewed_order_is_withdrawal',
    3: 'Withdrawal_successful',
    2: 'Withdrawal_Failed',
    4: 'Review_failed',
    5: 'To_be_determined',
    6: 'Cancel',
}
// 系统消息前缀
export const SYSTEM = 10000
// 交易消息前缀
export const TRANSACtiON = 20000

export enum MESSAGE_CODE {
    SYSTEM = 10000, // 系统
    TRANSACTION = 20000, // 交易
}

// 未登录时长链接请求缓存黑名单
export const BLACK_LIST = [GLOBAL_URL.SessionLogin]

export const CUREENCY_SYMBOL = {
    PHP: 'P',
    USD: '$',
}

// vip 权益图标
export const VIP_LEGAL_CONFIG = [
    {
        text: 'vip_newreward1',
        des: 'vip_newreward1_info',
        key: 'reward.gold',
    },
    {
        text: 'vip_newreward2',
        des: 'vip_newreward2_info',
        key: 'betRebate',
        type: 'thousandth',
        per: 1000,
        unit: '‰',
    },
    {
        text: 'vip_newreward3',
        des: 'vip_newreward3_info',
        key: 'monthReward.gold',
    },
    {
        text: 'vip_newreward4',
        des: 'vip_newreward4_info',
        key: 'weekRewardWorth',
    },

    {
        text: 'vip_newreward5',
        des: 'vip_newreward5_info',
        key: 'withdrawNoFeeTimes',
    },
    {
        text: 'vip_newreward6',
        des: 'vip_newreward6_info',
        key: 'depositBonus',
        type: 'percent',
        per: 100,
        unit: '%',
    },
    {
        text: 'vip_newreward7',
        des: 'vip_newreward7_info',
        key: 'withdrawAmount',
    },
    {
        text: 'vip_newreward8',
        des: 'vip_newreward8_info',
        key: 'rules.advanced',
    },
    {
        text: 'vip_newreward9',
        des: 'vip_newreward9_info',
        key: 'birthday',
    },
    {
        text: 'vip_newreward10',
        des: 'vip_newreward10_info',
        key: 'benefit',
    },
]
export const FORMATE_CURRENCY = ['IDR', 'NGN']

// 长链接
export const WS_HOST = {
    development: ['wss://h5ws0dev.wecardgame.com'],
    production: ['wss://cftgl.playtokapi.top', 'wss://cftconn.playtokapi.top', 'wss://s0.playtokapi.top'],
}

export const WS_SERVER = WS_HOST[import.meta.env.MODE]

export const CURRENCY_ENV = {
    development: [
        {
            currency: 'PHP',
            type: 1,
            picture: 'https://cach.kaxyx.top/currencyicon/d0fd682f-0ea0-41bc-b975-1f480fc447c1.png',
            clientcurrency: '₱',
            exchangeRate: '0.017',
        },
    ],
    production: [
        {
            currency: 'PHP',
            type: 1,
            picture: 'https://cach.kaxyx.top/currencyicon/fe282696-87bb-4acf-867c-4cd54efcfec6.png',
            clientcurrency: '₱',
            exchangeRate: '0.017',
        },
    ],
}
export const CURRENCY_LIST = CURRENCY_ENV[import.meta.env.MODE]

export const LANGUAGE_ENV = {
    development: [
        {
            language: 'tl-PH',
            show: 'Filipino',
        },
        {
            language: 'en-US',
            show: 'English(US)',
        },
    ],
    production: [
        {
            language: 'tl-PH',
            show: 'Filipino',
        },
        {
            language: 'en-US',
            show: 'English',
        },
    ],
}

export const CUREENCY_PAGE_MAP = {
    PHP: 'app_ph.html',
}

export const LANGUAGE_LIST = LANGUAGE_ENV[import.meta.env.MODE]
